

import { Box, FormHelperText, TextField, Typography, FormControlLabel, Checkbox, Button, IconButton, InputAdornment, OutlinedInput, List, ListItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextareaAutosize, Select, MenuItem, FormControl, RadioGroup, Radio, Tabs, Tab, Switch, styled, Modal, Menu, Collapse, Stack, Pagination, SwipeableDrawer ,Tooltip} from "@mui/material";


import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Link } from "react-router-dom";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { MuiOtpInput } from 'mui-one-time-password-input'

export default {
      Box,
      FormHelperText,
      TextField,
      Typography,
      FormControlLabel,
      Checkbox,
      Button,
      IconButton,
      InputAdornment,
      OutlinedInput,
      VisibilityOff,
      Visibility,
      Link,
      List,
      ListItem,
      Table,
      TableBody,
      TableCell,
      TableContainer,
      TableHead,
      TableRow,
      Paper,
      TextareaAutosize,
      Select,
      MenuItem,
      FormControl,
      RadioGroup,
      Radio,
      Tabs,
      Tab,
      Switch,
      styled,
      Modal,
      Menu,
      ExpandLess,
      ExpandMore,
      Collapse,
      Stack,
      Pagination,
      SwipeableDrawer,
      MuiOtpInput,
      Tooltip,
};
